// AdaMar support / contact channels. Single source of truth — edit here.
// WhatsApp +996 500 659 630 передан Jazuu (01.10.2026, AdaMar на паузе): на нём
// отвечает ассистент Jazuu, поэтому AdaMar его больше не показывает.
export const SUPPORT = {
  email: 'support@adamar.app',
  instagram: 'adamar_ai',
};
export const igLink = `https://instagram.com/${SUPPORT.instagram}`;
export const mailLink = (subject?: string) =>
  `mailto:${SUPPORT.email}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}`;
